<script>
export default {
  name: 'UniButton',
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    plain: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    loadingText: { type: String, default: 'Please wait...' },
  },
};
</script>

<template>
  <button
    v-bind="$attrs"
    type="button"
    class="btn"
    :class="{ 'btn-bc01': !plain, outlined: outlined }"
    :disabled="disabled || loading"
    v-on="$listeners"
  >
    <span v-if="loading">
      <i class="fas fa-fw fa-spin fa-spinner"></i>
      {{ loadingText }}
    </span>
    <slot v-if="!loading"></slot>
  </button>
</template>

<style scoped>
.outlined {
  border: 1px solid #00a2e1;
  color: #00a2e1;
  background-color: white;
}
</style>
